import { render, staticRenderFns } from "./RecruitmentTemplate.vue?vue&type=template&id=32d9416a&scoped=true"
import script from "./RecruitmentTemplate.vue?vue&type=script&lang=js"
export * from "./RecruitmentTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d9416a",
  null
  
)

export default component.exports